/**
 * The everyday name of a zone — `Central Time` — rather than its IANA id.
 *
 * `longGeneric` on purpose: the seasonal names ("Central Daylight Time") are
 * only right for one half of the year, and a booking read months later would
 * be labelled wrong. A runtime that can't name the zone gets the id back,
 * which is at least unambiguous.
 */
export const timeZoneLabel = (
  timeZone: string,
  on: Date = new Date()
): string => {
  if (!timeZone) return "";
  try {
    const named = new Intl.DateTimeFormat("en-US", {
      timeZone,
      timeZoneName: "longGeneric"
    })
      .formatToParts(on)
      .find((part) => part.type === "timeZoneName");
    return named?.value || timeZone;
  } catch {
    return timeZone;
  }
};
